import React from 'react';
import {
  Button,
  IconButton,
  Paper,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Tooltip,
  Divider,
  Checkbox,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
} from '@mui/material';
import { Add, Delete, Edit } from '@mui/icons-material';
import SearchIcon from '@mui/icons-material/Search';
import { DataGrid } from '@mui/x-data-grid';
import { ptBR } from "@mui/x-data-grid/locales";
import { D, SearchField, ConfirmDialog, C } from '../include';
import _ from 'underscore';




class EditDoctor extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      name: this.props.row ? this.props.row.name : '',
      graduation: this.props.row ? this.props.row.graduation : -1,
      company_id: this.props.row ? this.props.row.company_id : this.props.user.company_id,
      council_number: this.props.row ? this.props.row.council_number : "",
    };
  }

  handleSubmit = () => {
    if (!this.props.edit) {
      this.props.api
        .post('/Doctors/', { name: this.state.name, graduation: this.state.graduation, company_id: this.state.company_id, council_number: this.state.council_number })
        .then((r) => {
          this.props.dialogClose();
          if("error" in r)
            this.props.alert(r.error);
          else
            this.props.alert('Profissional de Saúde criado com sucesso');
        })
        .catch(() => this.props.alert('Ocorreu um erro ao criar o registro'));
    } else {
      this.props.api
        .put('/Doctor/' + this.props.row.id, { id: this.props.row.id, name: this.state.name, graduation: this.state.graduation, company_id: this.state.company_id, council_number: this.state.council_number })
        .then((r) => {
          this.props.dialogClose();
          if("error" in r)
            this.props.alert(r.error);
          else
            this.props.alert(r.message);
        })
        .catch(() => this.props.alert('Ocorreu um erro ao salvar alterações'));
    }
  };

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <DialogTitle style={{ minWidth: '400px' }}>
          {this.props.edit ? 'Editar Profissional de Saúde' : 'Adicionar Profissional de Saúde'}
        </DialogTitle>
        <DialogContent>
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="Nome"
            value={this.state.name}
            onChange={(e) => this.setState({ name: e.target.value })}
            required
          />
          <D h="1rem" />
          <TextField
            fullWidth
            variant="outlined"
            label="Número no Conselho Regional"
            value={this.state.council_number}
            onChange={(e) => this.setState({ council_number: e.target.value })}
            required
          />
          <D h="1rem" />
          <FormControl fullWidth>
            <InputLabel id="select-type">Habilitação</InputLabel>
            <Select
              labelId="select-type"
              id="select-t"
              value={this.state.graduation}
              label="Tipo"
              onChange={(e) => this.setState({graduation: e.target.value})}
            >
              {Object.keys(C.DoctorType).map(key => {
                  return <MenuItem key={key} value={key}>{C.DoctorType[key]}</MenuItem>
                })
              }
            </Select>
          </FormControl>
          {(this.props.user.role==="superuser") &&
            <>
              <D h="1rem" />
              <TextField
                fullWidth
                variant="outlined"
                label="Empresa"
                value={this.state.company_id}
                onChange={(e) => this.setState({ company_id: e.target.value })}
                required
              />
            </>
          }
          <D h="2rem" />
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="primary" onClick={this.props.dialogClose}>
            Cancelar
          </Button>
          <Button variant="outlined" color="primary" type="submit">
            Salvar
          </Button>
        </DialogActions>
      </form>
    );
  }
}

export class Doctor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchField: '',
      dataTable: [],
      loading: true,
      page: 0,
      pageSize: 25,
      totalRows: 0,
      selectedRows: [],
    };

    this.columns = [
      ...(this.props.permission === 'w'
        ? [
            {
              field: "check",
              headerName: "Seleção",
              width: 100,
              sortable: false,
              renderCell: (params) => (
                <Checkbox checked={this.state.selectedRows.includes(params.row) } onChange={() => this.onRowClick(params.row)} />
              ),
            },
          ]
        : []),
      { field: 'id', headerName: 'ID', width: 70 },
      { field: 'name', headerName: 'Nome', width: 250 },
      { field: 'typestring', headerName: 'Habilitação', width: 200 },
      { field: 'council_number', headerName: 'Conselho Regional', width: 150 },
      { field: 'company_id', headerName: 'Empresa', width: 90 },
    ];
  }

  componentDidMount() {
    this.updateData();
  }

  updateData = (page = this.state.page, pageSize = this.state.pageSize, searchField = this.state.searchField) => {
    this.setState({ loading: true });
    this.props.api
      .get('/Doctors', { params: { page, pageSize, search: searchField } })
      .then((r) => {
        for(var row in r.doctors){
          r.doctors[row]["typestring"] = C.DoctorType[ r.doctors[row]["graduation"] ];   
        }
        this.setState({
          dataTable: r.doctors || [],
          totalRows: Number(r.total) || 0,
          loading: false,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  handleSearch = () => {
    this.setState({ page: 0 }, () => {
      this.updateData(0, this.state.pageSize, this.state.searchField);
    });
  };

  handlePaginationModelChange = (newpagemodel, reason) => {
    var pageSizeChanged = (newpagemodel.pageSize === this.state.pageSize) ? false : true
        
    this.setState({ page: newpagemodel.page, pageSize: newpagemodel.pageSize }, () => {
      this.updateData(pageSizeChanged ? 0 : newpagemodel.page, newpagemodel.pageSize);
    });
  };

  onRowClick = (i) => {
    this.setState({
      selectedRows: this.state.selectedRows.includes(i) ? _.without(this.state.selectedRows, i) : _.union(this.state.selectedRows, [i])
    });
  };
  
  render() {
    const { searchField, dataTable, loading, page, pageSize, totalRows } = this.state;

    return (
      <D className="col e aF scD" style={{ padding: '2rem' }}>
        <D className="row w aF">
          <SearchField
            value={searchField}
            onChange={(v) => this.setState({ searchField: v })}
        />
        <Tooltip title="Pesquisar" arrow>
          <IconButton sx={{ marginLeft: '12px' }} onClick={this.handleSearch}>
            <SearchIcon />
          </IconButton>
        </Tooltip>
              
        {this.props.permission === 'w' && (
          <> 
              <Divider sx={{ paddingRight: '5px' }} orientation="vertical" flexItem />
              <D size="0.5rem" />

              {this.state.selectedRows.length === 1 && (
                <>
                  <Tooltip title="Editar item" arrow>
                    <IconButton
                      onClick={() =>
                        this.props.dialog(
                          <EditDoctor
                            edit
                            row={this.state.selectedRows[0]}
                            api={this.props.api}
                            alert={this.props.alert}
                            dialogClose={() => {
                              this.props.dialogClose();
                              this.setState({ selectedRows: [] });
                              this.updateData();
                            }}
                            user={this.props.user}
                          />
                        )
                      }
                    >
                      <Edit />
                    </IconButton>
                  </Tooltip>
                  <D size="0.5rem" />
                </>
              )}
                            
              {this.state.selectedRows.length > 0 && (
                <>
                  <Tooltip title="Excluir selecionados" arrow>
                    <IconButton
                      onClick={() =>
                        this.props.dialog(
                          <ConfirmDialog
                            title="Excluir Itens"
                            msg="Ao confirmar, os itens serão excluídos e não poderão ser recuperados"
                            reg={
                              this.state.selectedRows.length > 1
                                ? this.state.selectedRows.length + " registros selecionados"
                                : "1 registro selecionado"
                            }
                            onCancel={this.props.dialogClose}
                            onConfirm={() => {
                              for (let row of this.state.selectedRows) {
                                this.props.api
                                  .delete("/Doctor/" + row.id)
                                  .then((r) => {
                                    this.props.alert(r.message);
                                    this.props.dialogClose();
                                    this.setState({ selectedRows: [] });
                                    this.updateData();
                                  })
                                  .catch(() => this.props.alert("Ocorreu um erro ao excluir o registro"));
                              }
                            }}
                          />
                        )
                      }
                    >
                      <Delete />
                    </IconButton>
                  </Tooltip>
                  <D size="0.5rem" />
                </>
              )}
                            
              <D e />
              <Tooltip title="Inserir" arrow>
                <IconButton
                  sx={{ marginLeft: '12px' }}
                  onClick={() =>
                    this.props.dialog(
                      <EditDoctor
                        edit={false}
                        row={null}
                        api={this.props.api}
                        alert={this.props.alert}
                        dialogClose={() => {
                          this.props.dialogClose();
                          this.setState({ selectedRows: [] });
                          this.updateData();
                        }}
                        user={this.props.user}
                      />
                    )
                  }
                >
                  <Add />
                </IconButton>
              </Tooltip>
          </>
        )}
          </D>
        <D h="1rem" />
        
        <Paper sx={{ width: '100%', height: '800px', overflow: 'hidden' }}>
          <DataGrid
            rows={dataTable}
            columns={this.columns}
            pagination
            paginationMode="server"
            rowCount={totalRows}
            loading={loading}            
            pageSizeOptions={[25, 50, 100]}
            paginationModel={{pageSize: pageSize, page: page} }
            onPaginationModelChange={this.handlePaginationModelChange}            
            disableSelectionOnClick
            localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
          />
        </Paper>
      </D>
    );
  }
}
